(function() {
  let loading = false;
  let hasNextPage = true;

  const grid = document.querySelector('ul#product-grid');
  if (!grid) return;

  function getNextPageUrl() {
    const next = document.querySelector('.pagination a[href*="page="]');
    if (next) return next.href;
    const relNext = document.querySelector('link[rel="next"]');
    if (relNext) return relNext.href;
    return null;
  }

  function showWhatsAppBanner() {
    if (document.getElementById('repongo-wa-banner')) return;
    const banner = document.createElement('div');
    banner.id = 'repongo-wa-banner';
    banner.style.cssText = `
      width:100%; padding:32px 16px; text-align:center;
      background:#f0fdf4; border-top:3px solid #25D366;
      margin-top:32px; box-sizing:border-box;
    `;
    banner.innerHTML = `
      <p style="font-size:1.1rem;font-weight:600;margin-bottom:8px;color:#1a1a1a;">
        ¡Llegaste al final del catálogo!
      </p>
      <p style="font-size:1rem;margin-bottom:20px;color:#444;">
        ¿No encontrás lo que buscás? ¡Contanos qué producto necesitás!
      </p>
      <a href="https://wa.me/59896438483?text=Hola%20ReponGo!%20Me%20gustar%C3%ADa%20sumar%20a%20mi%20comercio%20un%20producto%20y%20no%20tengo%20proveedor,%20uds%20me%20pueden%20ayudar?" 
         target="_blank" rel="noopener"
         style="display:inline-flex;align-items:center;gap:10px;background:#25D366;color:#fff;
                padding:14px 28px;border-radius:50px;text-decoration:none;font-size:1rem;
                font-weight:600;box-shadow:0 4px 12px rgba(37,211,102,0.4);">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.855L0 24l6.335-1.502A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.006-1.371l-.36-.214-3.732.885.936-3.617-.235-.372A9.818 9.818 0 1112 21.818z"/>
        </svg>
        Escribinos por WhatsApp
      </a>
    `;
    sentinel.parentNode.insertBefore(banner, sentinel);
  }

  function showLoader() {
    if (document.getElementById('repongo-loader')) return;
    const loader = document.createElement('div');
    loader.id = 'repongo-loader';
    loader.style.cssText = 'width:100%;text-align:center;padding:24px;font-size:1rem;color:#666;';
    loader.textContent = 'Cargando más productos...';
    sentinel.parentNode.insertBefore(loader, sentinel);
  }

  function removeLoader() {
    const loader = document.getElementById('repongo-loader');
    if (loader) loader.remove();
  }

  async function loadNextPage() {
    if (loading || !hasNextPage) return;
    const nextUrl = getNextPageUrl();
    if (!nextUrl) {
      hasNextPage = false;
      showWhatsAppBanner();
      return;
    }

    loading = true;
    showLoader();

    try {
      const res = await fetch(nextUrl);
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newItems = doc.querySelectorAll('ul#product-grid > li');
      newItems.forEach(item => grid.appendChild(item));

      const oldPagination = document.querySelector('.pagination');
      const newPagination = doc.querySelector('.pagination');
      if (oldPagination && newPagination) {
        oldPagination.replaceWith(newPagination);
        document.querySelector('.pagination').style.display = 'none';
      } else if (oldPagination) {
        oldPagination.remove();
      }

      removeLoader();

      if (!getNextPageUrl()) {
        hasNextPage = false;
        showWhatsAppBanner();
      }
    } catch(e) {
      console.error('Infinite scroll error:', e);
      removeLoader();
    }
    loading = false;
  }

  // Ocultar paginación inicial
  const pagination = document.querySelector('.pagination');
  if (pagination) pagination.style.display = 'none';

  // Verificar si ya estamos en la última página
  if (!getNextPageUrl()) {
    hasNextPage = false;
  }

  const sentinel = document.createElement('div');
  sentinel.id = 'repongo-sentinel';
  sentinel.style.height = '1px';
  grid.parentNode.insertBefore(sentinel, grid.nextSibling);

  // Mostrar banner si ya estamos en la última página
  if (!hasNextPage) {
    showWhatsAppBanner();
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) loadNextPage();
  }, { rootMargin: '400px' });

  observer.observe(sentinel);

  // Disparar carga inicial si el sentinel ya es visible
  setTimeout(() => {
    const rect = sentinel.getBoundingClientRect();
    if (rect.top < window.innerHeight + 400) {
      loadNextPage();
    }
  }, 500);

})();
